import { envName } from "@faire/web--source/common/user-agent/envName";
export var isProduction = function() {
    return envName() === "production";
};
